<template>
	<div class="page" data-name="cgl-study-detail-info">
		<f7-navbar>
			<div class="title">
				우리학원 학습현황 
			</div>
			<f7-nav-right>
				<f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
			</f7-nav-right>
		</f7-navbar>
		<div class="page-content" style="background-color:#efeff4">
			<div class="row">
				<div class="wide-border-box title-box col-100 xsmall-100 small-100 medium-100 large-100 xlarge-100" style="height:300px;margin-top:10px">
					<div class="tb-title">
						<div class="left"><h3>월별 학습량</h3></div>
					</div>
					<div class="tb-body">
						<canvas class="total-month-chart" ref="totalMonthChart" style="width:100%; height:100%;"></canvas>
					</div>
				</div>    
			</div>
			<div class="row">
				<div class="wide-border-box title-box col-100 xsmall-100 small-100 medium-100 large-100 xlarge-100" style="height:200px;">
					<div class="tb-title">
						<div class="left">
							<h3>이번주 학습지도</h3>
						</div>
						<div class="right">
							<span data-progress="100" class="progressbar" style="width:16px; display:inline-block;"></span> 학생수&nbsp;&nbsp;
							<span data-progress="100" class="progressbar color-green" style="width:16px; display:inline-block;"></span> 학습량
						</div>
					</div>
					<div class="tb-body">
						<div class="progress-group">
							<p>홍길동 선생님</p>
							<p><span data-progress="30" class="progressbar"></span></p>
							<p><span data-progress="50" class="progressbar color-green"></span></p>
						</div>
						<div class="progress-group">
							<p>이순신 선생님</p>
							<p><span data-progress="20" class="progressbar"></span></p>
							<p><span data-progress="30" class="progressbar color-green"></span></p>
						</div>						
					</div>
				</div>
			</div>
			<div class="row">
 				<div class="wide-border-box title-box col-100 xsmall-100 small-100 medium-100 large-100 xlarge-100" style="height:200px;">
              <div class="tb-title">
                <div class="left">
                  <h3>이번주 위험지표</h3>
                </div>
                <div class="right">
                  <span data-progress="100" class="progressbar color-red" style="width:16px; display:inline-block;"></span> 퇴원생수&nbsp;&nbsp;
                  <span data-progress="100" class="progressbar color-orange" style="width:16px; display:inline-block;"></span> 미학습자수
                </div>
              </div>
              <div class="tb-body">
                <div class="progress-group">
                  <p>홍길동 선생님</p>
                  <p><span data-progress="30" class="progressbar color-red"></span></p>
                  <p><span data-progress="50" class="progressbar color-orange"></span></p>
                </div>
                <div class="progress-group">
                  <p>이순신 선생님</p>
                  <p><span data-progress="50" class="progressbar color-red"></span></p>
                  <p><span data-progress="70" class="progressbar color-orange"></span></p>
                </div>
                <div class="progress-group">
                  <p>홍길동 선생님</p>
                  <p><span data-progress="30" class="progressbar color-red"></span></p>
                  <p><span data-progress="50" class="progressbar color-orange"></span></p>
                </div>
                <div class="progress-group">
                  <p>이순신 선생님</p>
                  <p><span data-progress="50" class="progressbar color-red"></span></p>
                  <p><span data-progress="70" class="progressbar color-orange"></span></p>
                </div>           
              </div>
        </div>
			</div>
			<div class="row">
				<div class="wide-border-box title-box col-100 xsmall-100 small-100 medium-100 large-100 xlarge-100" style="height:200px;">
              <div class="tb-title">
                <div class="left">
                  <h3>이번주 활동</h3>
                </div>
                <div class="right">
                  <span data-progress="100" class="progressbar" style="width:16px; display:inline-block;"></span> 클리닉지&nbsp;&nbsp;
                  <span data-progress="100" class="progressbar color-green" style="width:16px; display:inline-block;"></span> 컨텐츠제작
                </div>
              </div>
              <div class="tb-body">
                <div class="progress-group">
                  <p>홍길동 선생님</p>
                  <p><span data-progress="30" class="progressbar"></span></p>
                  <p><span data-progress="50" class="progressbar color-green"></span></p>
                </div>
                <div class="progress-group">
                  <p>이순신 선생님</p>
                  <p><span data-progress="50" class="progressbar"></span></p>
                  <p><span data-progress="70" class="progressbar color-green"></span></p>
                </div>                
              </div>
			  </div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { f7 } from 'framework7-vue';
import MODULE from '../../../../js/common/module';
import PAGES from '../../../../js/pages';
import CONST from '../../../../js/common/constant';
import API from '../../../../js/common/api';
import AUTH from '../../../../js/common/auth';
import Chart from 'chart.js';

export default {
  data() {
    return {

    }
  },
  mounted() {
    let _this = this;
		_this.renderTotalMonthChart();	 
  },
  methods: {
  renderTotalMonthChart() {
			let _this = this;
			var chartConfig = {
				type: 'line',
				data: {
					labels: ['7월', '8월', '9월', '10월', '11월', '12월'],
					datasets: [
						{
							label: '학생수',
							yAxisID: 'student',
							data: [38, 62, 68, 75, 102, 88],
							backgroundColor: '#00ffaaa0',
							borderColor: '#00ffaaff',
							borderWidth: 2,
							fill: false,
						},
						{
							label: '총학습량',
							yAxisID: 'study',
							data: [3800, 62000, 6800, 75000, 1020, 8800],
							backgroundColor: '#00aaffa0',
							borderColor: '#00aaffff',
							borderWidth: 2,
							fill: true,
						}
					]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					title: {
						display: false,
						text: ''
					},
					tooltips: {
						mode: 'index',
						intersect: false,
					},
					hover: {
						mode: 'nearest',
						intersect: true
					},
					legend: {
						display: true,
						position: 'top',
						align: "end"
					},
					scales: {
						xAxes: [{
							display: true,
							scaleLabel: {
								display: false,
								labelString: '월'
							}
						}],
						yAxes: [{
							id: 'student',
							display: true,
							position: 'left',
							type: 'linear',
							ticks: {
								precision: 0,
								fontColor: '#00ffaaff'
							},
							scaleLabel: {
								display: false,
								labelString: '학생수'
							}
						},{
							id: 'study',
							display: true,
							position: 'right',
							type: 'linear',
							ticks: {
								precision: 0,
								fontColor: '#00aaffff'
							},
							scaleLabel: {
								display: false,
								labelString: '학습총량'
							}
						}]
					}
				}
			};

			var ctx = _this.$refs.totalMonthChart.getContext('2d');
			var chartObj = new Chart(ctx, chartConfig);
		},

  }
}

</script>
